import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/AboutSection.css';

const AboutSection: React.FC = () => {
  return (
    <section id="quem-somos" className="about-section">
      <Container>
        <div className="section-header">
          <span className="section-badge">Institucional</span>
          <h2 className="section-title">Sobre a Agricampanha</h2>
        </div>

        <div className="about-text">
          <p>
            A Agricampanha é a associação que representa os produtores rurais da Região da
            Campanha em Bagé/RS, unindo forças para fortalecer o agronegócio local.
          </p>
          <p>
            Nosso compromisso é estar sempre ao lado do produtor, defendendo seus interesses
            e trabalhando por um campo mais produtivo, sustentável e próspero para toda a
            Região da Campanha Gaúcha.
          </p>
        </div>

        {/* Foto centralizada */}
        <div
          className="about-photo-single"
          role="img"
          aria-label="Agricampanha"
          style={{ backgroundImage: "url('/img/galeria-quem-somos-3.jpg')" }}
        />

        {/* Separador */}
        <hr className="about-divider" />

        {/* Missão */}
        <div className="about-mission">
          <span className="section-badge">Nossa Missão</span>
          <p>
            "Representar, fortalecer e integrar os produtores rurais da Campanha,
            promovendo desenvolvimento sustentável e responsabilidade social."
          </p>
        </div>
      </Container>
    </section>
  );
};

export default AboutSection;
